import React from 'react';
import { useNavigate } from 'react-router-dom';

import ProfileImage from '../../ProfileImage/ProfileImage';
import FieldBold from '../../Fields/FieldBold/FieldBold';
import Button from '../../Buttons/Button/Button';
import Tags from '../../Tags/Tags';
import { paths } from '../../../routes';

import classes from './CardCollaborators.module.scss';
import { statusAccountLabel } from '../../../store/constants/statusDruoAccounts';
import { documentTypesAbbreviationsObject } from '../../../store/catalogs/documentTypes';

const CardCollaborators = ({ collaborator, isTag }) => {
  const navigate = useNavigate();

  const { druoAccounts } = collaborator;

  const goToCollaborator = () => {
    navigate(paths.collaborator.replace(':collaboratorId', collaborator.collaboratorId));
  };

  return (
    <div className={`${classes.card} card-collaborator`}>
      <div className={classes.info}>
        <ProfileImage className={`${classes.icon} semibold-60`} name={collaborator.name} lastName={collaborator.lastName} />
        <div>
          <div className={classes.name}>
            <div className={classes.status}>
              <span className='semibold-18'>{collaborator.name}</span>
              {isTag && (
                <Tags
                  text={druoAccounts.length === 0 ? 'Sin cuenta' : statusAccountLabel[druoAccounts[0].meloStatus].label}
                  type={druoAccounts.length === 0 ? 'orange' : statusAccountLabel[druoAccounts[0].meloStatus].color}
                />
              )}
            </div>
            <span className={`medium-16 ${classes.color}`}>{collaborator.positionLabel}</span>
          </div>
          <FieldBold
            title='IDENTIFICACIÓN'
            value={`${documentTypesAbbreviationsObject[collaborator.identificationType]} ${collaborator.identificationNumber}`}
          />
        </div>
      </div>
      <Button onClick={goToCollaborator} className={classes.button} custom='quaternary'>
        Ver perfil
      </Button>
    </div>
  );
};

export default CardCollaborators;
